import { render, staticRenderFns } from "./ColumnTask.vue?vue&type=template&id=4e71b8ea&"
import script from "./ColumnTask.vue?vue&type=script&lang=js&"
export * from "./ColumnTask.vue?vue&type=script&lang=js&"
import style0 from "./ColumnTask.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports